import { Home } from 'lucide-react';
import { Bet,TotalOdd } from '../types';
import {VersionedState } from './state';
export const removeBets = (state: VersionedState, payload: any): VersionedState => {
  const betsToRemove = Array.isArray(payload) ? payload : [payload];
  let remainingBets = state.bets.filter(
    bet =>
      !betsToRemove.some(
        remove =>
          bet.id.toString() === remove.id.toString() &&
          bet.eventId.toString() === remove.eventId.toString()
      )
  );
  const eventIdToBets = new Map<string, Bet[]>();
  for (const bet of remainingBets) {
    const eventKey = bet.eventId.toString();
    if (!eventIdToBets.has(eventKey)) {
      eventIdToBets.set(eventKey, []);
    }
    eventIdToBets.get(eventKey)!.push(bet);
  }

  const filteredBets: Bet[] = [];
  const affectedEventIds = new Set<string>(
    betsToRemove.map(b => b.eventId.toString())
  );

  for (const [eventId, bets] of eventIdToBets.entries()) {
    if (bets.length > 1) {
      if (affectedEventIds.has(eventId)) {
        bets[0] = { ...bets[0], isDirty: true };
      }
      filteredBets.push(...bets);
    }
  }
  const validEventTotalOddsIds = new Set(filteredBets.map(bet => bet.eventId.toString()));
  const filteredTotalOdds = state.totalOdds.filter(odd =>
    validEventTotalOddsIds.has(odd.eventId.toString())
  );

  return {
    ...state,
    bets: filteredBets,
    totalOdds: filteredTotalOdds,
  };
};


export const addBets = (state: VersionedState, payload: any): VersionedState =>{
    const incomingBets: Bet[] = Array.isArray(payload) ? payload : [payload];
      const updatedBetsMap = new Map<string, Bet>();
      state.bets.forEach(bet => {
        updatedBetsMap.set(`${bet.id}_${bet.eventId}`, bet);
      });
     
      incomingBets.forEach(betData => {
        const key = `${betData.id}_${betData.eventId}`;
        const rb: Bet = {
          eventId: betData.eventId,
          eventName: betData.eventName,
          marketName: betData.marketName,
          id: betData.id,
          odds: betData.odds,
          selectionName: betData.selectionName,
          closed: betData.closed,
          date: betData.date,
          isDirty: true,
          line: betData.line,
          previouseOdds: betData.odds,
          suspended: betData.suspended,
          eventClosed: betData.eventClosed,
          eventSuspended: betData.eventSuspended,
          eventStatus: betData.eventStatus,
          lineStatus: betData.lineStatus,
          autoRemoved:false,
          addOnError:false,
          away:betData.away,
          home:betData.home,
          eventSeperator:betData.eventSeperator,
          fixtureId:betData.fixtureId
          
        };
        updatedBetsMap.set(key, rb);
      });
      const newBetsArray: Bet[] = Array.from(updatedBetsMap.values());
        return {
        ...state,
        bets: newBetsArray,
      };
}
export const recalculate = (state: VersionedState, payload: any): VersionedState =>{
    const incomingBets: Bet[] = Array.isArray(payload) ? payload : [payload];
    const updatedBetsMap = new Map<string, Bet>();
    state.bets.forEach(bet => {
        updatedBetsMap.set(`${bet.id}_${bet.eventId}`, bet);
    });
     
    incomingBets.forEach(betData => {
        const key = `${betData.id}_${betData.eventId}`;
        const rb: Bet = {
            eventId: betData.eventId,
            eventName: betData.eventName,
            marketName: betData.marketName,
            id: betData.id,
            odds: betData.odds,
            selectionName: betData.selectionName,
            closed: betData.closed,
            date: betData.date,
            isDirty: true,
            line: betData.line,
            previouseOdds: betData.odds,
            suspended: betData.suspended,
            eventClosed: betData.eventClosed,
            eventSuspended: betData.eventSuspended,
            eventStatus: betData.eventStatus,
            lineStatus: betData.lineStatus,
            autoRemoved:false,
            addOnError:false,
            away:betData.away,
            home:betData.home,
            eventSeperator:betData.eventSeperator,
            fixtureId:betData.fixtureId
          
        };
        updatedBetsMap.set(key, rb);
    });
    const newBetsArray: Bet[] = Array.from(updatedBetsMap.values());
    return {
        ...state,
        bets: newBetsArray,
    };
}

export const setTotalOdds = (state: VersionedState, payload: any): VersionedState => {
  const dirtyBets = [...state.bets].map(bet => ({
    ...bet,
    isDirty: false,
  }));

  const validEventIds = new Set(dirtyBets.map(b => b.eventId.toString()));
  const oddsMap = new Map<string, TotalOdd>();
  state.totalOdds.forEach(odd => {
    if (validEventIds.has(odd.eventId.toString())) {
      oddsMap.set(odd.eventId.toString(), { ...odd, previouseOdds: odd.odd });
    }
  });
  
  payload.forEach((incomingOdd: TotalOdd) => {
    if (validEventIds.has(incomingOdd.eventId.toString())) {
      const previous = oddsMap.get(incomingOdd.eventId.toString());
      oddsMap.set(incomingOdd.eventId.toString(), {
        ...incomingOdd,
        previouseOdds: previous ? previous.odd : -1,
      });
    }
  });
  const mergedTotalOdds = Array.from(oddsMap.values());
  return {
    ...state,
    bets: dirtyBets,
    totalOdds: mergedTotalOdds,
  };
};
export const removeEvent = (state: VersionedState, payload: any): VersionedState =>{
    return  {
        ...state,
        bets: state.bets.filter(bet => bet.eventId.toString() !== payload.toString()),
        totalOdds: state.totalOdds.filter(o=>o.eventId.toString()!== payload.toString())
    };
}